import CustomZObject from './CustomZObject.js';
import ParameterContext from "effects/ParameterContext.js";
import {AbstractParameter} from "parameters/AbstractParameter.js";
import {
    setEffectParameterValues,
    setEffectParameterValue} from 'actions/index.js';
import Tone from 'tone';
import Registered from "utils/Registered.js";
import ParamMappable from "effects/midi/mappable/ParamMappable.js";
import ParamDisableable from "effects/midi/mappable/ParamDisableable.js"


export default class ZMacro extends ParamMappable(ParamDisableable(Registered(CustomZObject))) {
    constructor(zobject) {
        super(zobject, false);
        this.store = zobject.sequencerEngine.store;
        this.track = zobject;
        this.parameters = [];
        this.loaded = true;
        this.valueParameter = new AbstractParameter(
            "value",
            this,
            (o, x, automation, time) => this.onValue(x, time),
            {
                defaultValue: 0
            });

        this.setupRampParameters();
        zobject.effect = this;
        this.value = 0;
        this.context = new ParameterContext()
            .forZObject(this);
        this.newInlet(
            "value", ([val]) => this.setValue(val));
        this.newInlet(
            "map parameter", ([map]) => this.onMapParameter(map));
        this.newOutlet(
            "value changed");

        this.newOutlet(
            "map parameter ");
    }

    onMapParameter(map) {
        if (!map.audioParam && !Array.isArray(map)) {
            return;
        }
        let parameter, depth;
        if (map.audioParam) {
            // its a parameter
            parameter = map;
            if (parameter.name === "depth") {
                parameter.set(0);
            }
            depth = 100;
        } else {
            let [effect, parameterName, _depth] = map;
            depth = _depth;
            
            if (!parameterName || !effect) {
                return;
            }
            
            // find the parameter
            parameter = effect.parameters.find(x => x.name.toLowerCase().includes(parameterName.toLowerCase()));
        }
        if (!parameter) {
            return;
        }
        if (!this._parameters.includes(parameter) && (!this.lostParameters || !this.lostParameters.find || !this.lostParameters.find(x => x.id === parameter.id))) {
            this.setParameter(parameter);
        }

        if (this.depthParameters[this._parameters.length - 1]) {
            this.depthParameters[this._parameters.length - 1].set(depth || 1);
        }
    }

    getJson() {
        return {
            ... this.getMappableJson(),
            id: this.id,
            value: this.value
        };
    }

    fromJson(json) {
        this.loaded = false;
        this.id = json.id;
        this.sequencerEngine.idToObject[this.id] = this;
        if (json.value) {
            this.value = json.value;
        }

        super.fromJson(json);
        this.loaded = true;
    }


    sortParameters() {}

    get min() {
        return 0;
    }
    get max() {
        return 1;
    }

    set value(x) {
        this.valueParameter.set(x);
    }

    get value() {
        return this.valueParameter.get();
    }

    setValue(val) {
        this.valueParameter.set(val, false);
    }

    onValue(val=this.value, time=Tone.Master.context.currentTime) {
        if (!this.loaded) {
            return;
        }
        if (val === this.lastValue) {
            return;
        }
        this.sequencerEngine.dispatch(
            setEffectParameterValue(this.id, val));
        let bulk = {};
        for (let i=0; i < this._parameters.length; i++) {
            let parameter = this._parameters[i];
            let {max, min} = parameter;
            let depth = this.getDepth(i);
            let initialValue = this.initialParameterValues[i];
            let pivot = depth < 0 ? (initialValue - min) : (max - initialValue);
            let _value = initialValue  +
                (val * (this.getDepth(i) / 100.0)) * pivot ;
            let {id, value} = parameter.set(
                Math.min(max, Math.max(min, _value)),
                true,
                true,
                time,
                this.rampTime / 1000.0);
            bulk[id] = value;
        }
        this.lastValue = val;
        this.sequencerEngine.dispatch(
            setEffectParameterValues(bulk));
        this.sendMessage("value changed", val);
    }
}
